import { render, staticRenderFns } from "./select_ares_language.vue?vue&type=template&id=0636faec"
import script from "./select_ares_language.vue?vue&type=script&lang=js"
export * from "./select_ares_language.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports